/**
 * POWÓD WYMUSZONEGO WYLOGOWANIA — jedno zdanie, które ma zobaczyć pracownik na ekranie logowania.
 *
 * [polecenie właściciela 2026-10-04, lista dozwolonych logowań] Gdy administrator włączy listę firmy (albo usunie z niej
 * osobę), sesja tej osoby kończy się przy najbliższym odświeżeniu: serwer odpowiada 401 z kodem `lista_logowan` i zdaniem
 * „Twoje konto Office 365 nie jest na liście osób dopuszczonych…”. Dotąd każda odmowa odświeżenia sesji kończyła się
 * przekierowaniem na ekran logowania BEZ słowa — człowiek widziałby pusty formularz i dzwonił, że „wyrzuciło go z aplikacji”.
 *
 * Zdanie przechodzi przez `sessionStorage` (przekierowanie przeładowuje stronę), ekran logowania pokazuje je RAZ i kasuje.
 * Zapamiętujemy wyłącznie odmowę z tym kodem — pozostałe powody wylogowania (wygasła sesja, wylogowanie na innej karcie)
 * zostają bez komunikatu, jak dotąd.
 */
export const KLUCZ_POWODU_WYLOGOWANIA = "logowanie.powod";

export const KOD_LISTY_LOGOWAN = "lista_logowan";

/** Zapisuje zdanie z odmowy serwera, jeśli to odmowa listy dozwolonych logowań. Nigdy nie rzuca. */
export const zapamietajPowodWylogowania = (blad) => {
    try {
        const dane = blad && blad.response ? blad.response.data : null;
        if (!dane || typeof dane !== "object" || dane.code !== KOD_LISTY_LOGOWAN) return false;
        if (typeof dane.message !== "string" || !dane.message.trim()) return false;
        sessionStorage.setItem(KLUCZ_POWODU_WYLOGOWANIA, dane.message.trim());
        return true;
    } catch {
        return false;
    }
};

/** Oddaje zapamiętane zdanie i od razu je kasuje (pokazujemy je raz). `null`, gdy niczego nie ma. */
export const odbierzPowodWylogowania = () => {
    try {
        const powod = sessionStorage.getItem(KLUCZ_POWODU_WYLOGOWANIA);
        if (powod) sessionStorage.removeItem(KLUCZ_POWODU_WYLOGOWANIA);
        return powod && powod.trim() ? powod.trim() : null;
    } catch {
        return null;
    }
};
